/*
  IW Nuevo brand landing ("Funda de disco"). Progressive enhancement only; every part works
  without this file.
  1. In-place add to cart. Each track's form is a real POST to /cart/add; here it becomes an
     add that keeps the visitor on the page: "Agregar" -> "Agregando…" -> "En tu carro" (a link
     to the cart, same box, so the row never moves). The header cart count refreshes. Errors
     show in amber under the button.
  2. Video facades. Each video is a link to YouTube; a tap swaps it for a youtube-nocookie.com
     player in the same 16:9 box. Nothing from YouTube loads before the tap but the thumbnail.
  3. Gallery. The strip is native scroll-snap; this adds the "1/6" counter and the arrows.
  4. Spec tables. The hint "Desliza la tabla…" is visible by default; here it hides whenever the
     whole table already fits its box.
  The entrance motion is CSS only (assets/iw-brand-landing.css).
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function scrollBehavior() {
    return reduceMotion && reduceMotion.matches ? 'auto' : 'smooth';
  }

  /* ── 1. Add to cart ─────────────────────────────────────────────── */

  function sectionHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('.shopify-section');
    return node ? node.innerHTML : html;
  }

  function refreshBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) bubble.innerHTML = sectionHTML(sections['cart-icon-bubble']);
  }

  function addUrl(form) {
    var action = form.getAttribute('action') || '/cart/add';
    return action.replace(/\/?$/, '') + '.js';
  }

  function onSubmit(event) {
    var form = event.target.closest('[data-iwbl-add]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    if (form.classList.contains('is-loading') || form.classList.contains('is-added')) return;

    var button = form.querySelector('[data-iwbl-add-btn]');
    var link = form.querySelector('[data-iwbl-cart-link]');
    var status = form.querySelector('[data-iwbl-status]');
    var error = form.querySelector('[data-iwbl-error]');
    var body = new FormData(form);
    body.append('sections', 'cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    function fail(message) {
      form.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      if (status) status.textContent = '';
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
    }

    form.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Agregando al carro…';
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    fetch(addUrl(form), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          var message = result.data && (result.data.description || result.data.message);
          fail(message || 'No se pudo agregar. Intenta de nuevo.');
          return;
        }

        refreshBubble(result.data.sections);
        // PUB_SUB_EVENTS is a top-level const in constants.js, so it is not a window property.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'iw-brand-landing', cartData: result.data });
        }

        var hadFocus = document.activeElement === button;
        form.classList.remove('is-loading');
        form.classList.add('is-added');
        button.removeAttribute('aria-busy');
        if (link) {
          button.hidden = true;
          link.hidden = false;
          if (hadFocus) link.focus();
        }
        if (status) status.textContent = 'Agregado al carro.';
      })
      .catch(function () {
        fail('No se pudo agregar. Revisa tu conexión e intenta de nuevo.');
      });
  }

  /* ── 2. Video facades ───────────────────────────────────────────── */

  function onClick(event) {
    var facade = event.target.closest('[data-iwbl-video]');
    if (!facade) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var id = facade.getAttribute('data-iwbl-video');
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    event.preventDefault();

    var iframe = document.createElement('iframe');
    /* autoplay only answers the tap that asked for the video; nothing plays on its own */
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    iframe.title = facade.getAttribute('data-iwbl-video-title') || 'Video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.setAttribute('allowfullscreen', '');
    facade.parentNode.replaceChild(iframe, facade);
    iframe.focus();
  }

  /* ── 3. Gallery counter and arrows ──────────────────────────────── */

  function initGallery(gallery) {
    if (gallery.dataset.iwblReady === '1') return;
    var scroller = gallery.querySelector('[data-iwbl-track]');
    var nav = gallery.querySelector('[data-iwbl-gallery-nav]');
    if (!scroller || !nav) return;
    var shots = scroller.querySelectorAll('[data-iwbl-shot]');
    if (shots.length < 2) return;
    gallery.dataset.iwblReady = '1';

    var count = nav.querySelector('[data-iwbl-count]');
    var prev = nav.querySelector('[data-iwbl-prev]');
    var next = nav.querySelector('[data-iwbl-next]');
    var leftmost = 0;
    var frame = 0;

    function startEdge() {
      var pad = parseFloat(window.getComputedStyle(scroller).scrollPaddingLeft) || 0;
      return scroller.getBoundingClientRect().left + pad;
    }

    function atEnd() {
      return scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
    }

    function update() {
      frame = 0;
      var edge = startEdge();
      var best = 0;
      var bestDistance = Infinity;
      for (var i = 0; i < shots.length; i += 1) {
        var distance = Math.abs(shots[i].getBoundingClientRect().left - edge);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      }
      leftmost = best;
      /* At the end of the strip the last photo counts as the current one. */
      count.textContent = String(atEnd() ? shots.length : best + 1);
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = atEnd();
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function go(index) {
      var target = shots[Math.max(0, Math.min(shots.length - 1, index))];
      var delta = target.getBoundingClientRect().left - startEdge();
      scroller.scrollBy({ left: delta, behavior: scrollBehavior() });
    }

    prev.addEventListener('click', function () {
      go(leftmost - 1);
    });
    next.addEventListener('click', function () {
      go(leftmost + 1);
    });
    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    nav.hidden = false;
    update();
  }

  /* ── 4. Spec tables ─────────────────────────────────────────────── */

  function initTable(scroller) {
    var part = scroller.closest('.iwbl-specs');
    var hint = part ? part.querySelector('[data-iwbl-table-hint]') : null;
    if (!hint) return;

    /* When the table fits there is nothing to scroll, so the region leaves the tab order. */
    function update() {
      var fits = scroller.scrollWidth <= scroller.clientWidth + 2;
      hint.hidden = fits;
      if (fits) {
        scroller.removeAttribute('tabindex');
      } else {
        scroller.setAttribute('tabindex', '0');
      }
    }

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(update);
      observer.observe(scroller);
      if (scroller.firstElementChild) observer.observe(scroller.firstElementChild);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  /* ── Wiring ─────────────────────────────────────────────────────── */

  function init(root) {
    if (root.dataset.iwblReady === '1') return;
    root.dataset.iwblReady = '1';
    root.addEventListener('submit', onSubmit);
    root.addEventListener('click', onClick);
    root.querySelectorAll('[data-iwbl-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-iwbl-table]').forEach(initTable);
  }

  function initAll() {
    document.querySelectorAll('[data-iwbl-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor re-renders sections: bind the fresh root. */
  document.addEventListener('shopify:section:load', initAll);
})();
